import { z } from "zod";
import { zSafeString } from "@/lib/validators/safe-zod";
import { timeZoneSchema } from "@/lib/timeZones";

/**
 * Schema for updating organization data
 * Used for PATCH /api/organizations endpoint
 */
export const updateOrganizationSchema = z
  .object({
    name: zSafeString()
      .min(2, "Organization name must be at least 2 characters")
      .max(255, "Organization name must be less than 255 characters")
      .optional(),
    domain: z
      .string()
      .min(1, "Domain cannot be empty")
      .regex(
        /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/,
        "Domain must be in valid format (e.g. company.com)"
      )
      .optional()
      .nullable(),
    description: z.record(z.string(), z.unknown()).optional().nullable(),
    timeZone: timeZoneSchema.optional().nullable(),
  })
  .refine(
    (data) => {
      // At least one field must be provided for update
      return (
        data.name !== undefined ||
        data.domain !== undefined ||
        data.description !== undefined ||
        data.timeZone !== undefined
      );
    },
    {
      message:
        "At least one field (name, domain, description, or timeZone) must be provided for update",
    }
  );

export type UpdateOrganizationSchemaType = z.infer<
  typeof updateOrganizationSchema
>;
